import React, { FC } from 'react';

import s from './PostContainer.module.scss';
import {IWpArticlePost, IWpGuidePost, IWpVideoPost} from '../../../../types/wordpress.types';

interface IPostContainer {
  post: IWpArticlePost | IWpVideoPost | IWpGuidePost
}

export const PostContainer: FC<IPostContainer> = ({ children, post }) => {
  
  return (
    <div className={`${s.postContainer} post-container`}>
      <div className={s.postContainer__wrapper}>
        {children}
      </div>
    </div>
  );
};
